import React from 'react';
import axios from 'axios';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import grey from '@material-ui/core/colors/grey';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import PupilField from '../parts/PupilField';

const styles = theme => ({
  fieldsNotFound: {
    color: grey[500]
  },
  caption: {
    backgroundColor: '#fafafa',
    border: '1px solid #eeeeee',
    borderRadius: 3,
    padding: 24,
    marginBottom: 20,
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
  };
};

class CustomFieldsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      isLoading: true,
      isLoaded: false,
      meta: [],
    };

    this.axiosCancel = null;
  }

  componentDidMount() {
    const {
      selectedPupil
    } = this.props;

    axios
      .get(
        `${window.apiUrl}/customfields/${selectedPupil.id}`,
        {
          cancelToken: new axios.CancelToken((c) => {
            this.axiosCancel = c
          }),
        }
      )
      .then(response => {
        if (response.data.success) {
          this.setState({
            data: response.data.data,
            meta: response.data.meta,
          });
        }

        this.setState({
          isLoading: false,
          isLoaded: true,
        });
      })
      .catch((thrown) => {});
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  render() {
    const {
      data,
      isLoaded
    } = this.state;

    const {
      t,
      classes,
      selectedPupil,
    } = this.props;

    return (
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        className="custom-fields-page"
      >
        {isLoaded && (
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="left"
            md={8}
            spacing={3}
          >
            {data.length === 0 && (
              <Grid
                item
                xs={12}
              >
                <Typography
                  variant="h5"
                  className={classes.fieldsNotFound}
                  align="center"
                >
                  {
                    appType === 'parent'
                      ? t('{{name}} does not have any pupil fields.', {name: selectedPupil.name})
                      : t('You do not have any pupil fields.')
                  }
                </Typography>
              </Grid>
            )}
            {data.hasOwnProperty('note') && data.note.length > 0 && (
              <Grid item xs={12}>
                <div className={classes.caption}>{data.note}</div>
              </Grid>
            )}
            {data.hasOwnProperty('fields') > 0 && data.fields.length > 0 && data.fields.map((field, index) => (
              <Grid
                item
                xs={12}
                md={6}
                key={field.id}
              >
                <PupilField
                  index={index + 1}
                  field={field}
                  useSuspense={false}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Grid>
    );
  }
}

export default connect(mapStateToProps, null)(
  withStyles(styles)(withSnackbar(withTranslation()(CustomFieldsPage)))
);
